/**
 * Counsel-editable constants for cold-path BAA (MD3C, LLC as Business Associate).
 * Update MD3C_PRINCIPAL_ADDRESS and master signature fields when counsel finalizes.
 */

export const MD3C_LEGAL_NAME = 'MD3C, LLC';

/** State of organization (formation). */
export const MD3C_STATE_OF_FORMATION = 'Illinois';

/**
 * Principal place of business — replace with counsel-approved mailing address before removing DRAFT.
 */
export const MD3C_PRINCIPAL_ADDRESS =
  '[Principal place of business for MD3C, LLC — to be inserted by counsel]';

/** Governing law for the BAA (user-confirmed: Illinois). */
export const MD3C_BAA_GOVERNING_LAW = 'the State of Illinois';

/**
 * Date of MD3C’s master BAA framework (one-time company signature).
 * Update when counsel dates the master counterpart.
 */
export const MD3C_BAA_MASTER_FRAMEWORK_DATE = 'March 28, 2026';

export const MD3C_BAA_SIGNATORY_NAME = '[Authorized signatory — master framework]';

export const MD3C_BAA_SIGNATORY_TITLE = 'Authorized Representative';

/** Bump when BAA body text changes materially (must match stored providerCmrBaaDocumentVersion). */
export const COLD_PATH_BAA_DOCUMENT_VERSION = 'draft-2026-03-28-baa-v2';
